import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCN from './zh-CN';
import enUS from './en-US';

Vue.use(VueI18n);

const messages = {
  'zh-CN': {
    ...zhCN
  },
  'en-US': {
    ...enUS
  }
};

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh-CN', // set locale
  fallbackLocale: 'zh-CN', // set fallback locale
  messages // set locale messages
});

export default i18n;
